module.exports = __webpack_public_path__ + "img/V-45-ER-1000-BE.40979de4.png";